import { useEffect, useState } from 'react';
import api from '../../api/axios';

const SITE_FIELDS = [
  { key: 'name',             label: 'Organisation Name',  type: 'text' },
  { key: 'tagline',          label: 'Tagline',            type: 'text' },
  { key: 'facebookUrl',      label: 'Facebook URL',       type: 'text' },
  { key: 'abn',              label: 'ABN',                type: 'text' },
  { key: 'registrationNo',   label: 'Registration No',    type: 'text' },
  { key: 'organizationName', label: 'Full Legal Name',    type: 'text' },
];

export default function ContentEditor() {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    api.get('/content/site')
      .then(r => setData(r.data || {}))
      .catch(() => setError('Failed to load site settings'))
      .finally(() => setLoading(false));
  }, []);

  const set = (k, v) => setData(d => ({ ...d, [k]: v }));

  const save = async (e) => {
    e.preventDefault();
    setSaving(true); setError(''); setSaved(false);
    try {
      await api.put('/content/site', data);
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch (err) {
      setError(err.response?.data?.error || 'Save failed');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="text-center py-5"><div className="spinner-border text-primary"></div></div>;

  return (
    <div>
      <div className="mb-4">
        <h4 className="fw-bold mb-0">Site Settings</h4>
        <p className="text-muted small mb-0">Edit core website information shown in the header, footer, and meta tags.</p>
      </div>

      {error && <div className="alert alert-danger py-2">{error}</div>}
      {saved && <div className="alert alert-success py-2"><i className="fas fa-check-circle me-2"></i>Settings saved successfully.</div>}

      <form onSubmit={save}>
        <div className="card border-0 shadow-sm">
          <div className="card-body p-4">
            <div className="row g-3">
              {SITE_FIELDS.map(({ key, label }) => (
                <div key={key} className="col-md-6">
                  <label className="form-label small fw-bold">{label}</label>
                  <input
                    type="text"
                    className="form-control"
                    value={data[key] || ''}
                    onChange={e => set(key, e.target.value)}
                  />
                </div>
              ))}

              <div className="col-12">
                <hr className="my-2" />
                <label className="form-label small fw-bold">Logo Image URL</label>
                <input
                  type="text"
                  className="form-control"
                  value={data.logo?.src || ''}
                  onChange={e => set('logo', { ...(data.logo || {}), src: e.target.value })}
                />
                {data.logo?.src && (
                  <img src={data.logo.src} alt="logo preview" style={{ height: 60, marginTop: 8, borderRadius: 6, border: '1px solid #eee', padding: 4, background: '#fff' }} />
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-3">
          <button type="submit" disabled={saving} className="btn btn-primary rounded-pill px-5">
            {saving ? <><span className="spinner-border spinner-border-sm me-2"></span>Saving…</> : 'Save Settings'}
          </button>
        </div>
      </form>
    </div>
  );
}
